<template>
	<el-tree-select style="width:100%;"
	    v-model="current"
	    :data="list"
	    filterable
	/>
</template>

<script>
	import axios from 'axios';
	import { ElMessage,ElMessageBox,ElNotification} from 'element-plus';
	import tool from "@/utils/tool";
	export default{
		props:{
			request:{
				type:Object,
				default:{
					url:'',
					params:{},
					method:"get"
				}
			},
			datakey:{//适配转化为data的对应字段
				type:String,
				default:''
			},
			labelkey:{//适配转化为label的对应字段
				type:String,
				default:''
			},
			valuekey:{//适配转化为value的对应字段
				type:String,
				default:''
			},
			childrenkey:{//适配转化为children的对应字段
				type:String,
				default:'children'
			},
			modelValue:{
				type:String,
				default:''
			}
		},
		data(){
			return{
	            current:'',
				list:''
			}
		},
		mounted(){
			
		},
		created(){
			this.current=this.modelValue;
			this.getData();
		},
		watch:{
			current(val) {
				if(val){
					this.$emit('update:modelValue', val)
				}
			},
		},
		methods:{
			/*请求选项*/
			getData(){
				var that=this;
				if(this.request.url){
					axios({
						method:this.request.method||'get',
						url:this.request.url,
						params:this.request.params||{}
					}).then((response) => {
						if(response.data&&response.data.data){
							if(that.datakey){
								that.list=that.transData(response.data.data[that.datakey]);
							}else{
								that.list=that.transData(response.data.data);
							}
						}
					}).catch((error) => {
						ElNotification.error({
							title: '请求错误',
							message:'服务器发生错误！'
						});
					})
				}
			},
			/*转换数据为选项格式*/
			transData($arr){
				var that=this,validArr=[];
				for(let i=0;i<$arr.length;i++){
					let obj={};
					obj.value=$arr[i][that.valuekey];
					obj.label=$arr[i][that.labelkey];
					if($arr[i][that.childrenkey]&&$arr[i][that.childrenkey].length){
						obj.children=that.transData($arr[i][that.childrenkey]);
					}
					validArr.push(obj);
				}
				return validArr;
			}
		}
	}
</script>

<style>
</style>
